import types from '../types'

const state = {
    white: true,
    menuBtn: true,
    backBtn: false,
    homeBtn: false,
    utilBtn: false,
    drawer: false,
    title: false,
    hide: false,
    color: false
}

const mutations = {
    // eslint-disable-next-line no-unused-vars
    [types.appBar.mutations.updateWhite] (state, { white }) {
        // state.white = white
        state.white = true
    },
    [types.appBar.mutations.menuBtn] (state, { menuBtn }) {
        state.menuBtn = menuBtn
    },
    [types.appBar.mutations.utilBtn] (state, { utilBtn }) {
        state.utilBtn = utilBtn
    },
    [types.appBar.mutations.backBtn] (state, { backBtn }) {
        state.backBtn = backBtn
    },
    [types.appBar.mutations.homeBtn] (state, { homeBtn }) {
        state.homeBtn = homeBtn
    },
    [types.appBar.mutations.drawer] (state, { drawer }) {
        state.drawer = drawer
    },
    [types.appBar.mutations.hide] (state, { hide }) {
        state.hide = hide
    },
    [types.appBar.mutations.title] (state, { title }) {
        state.title = title
    },
    [types.appBar.mutations.color] (state, { color }) {
        state.color = color
    }
}

const actions = {
    [types.appBar.actions.updateWhite] ({ commit }, { white }) {
        commit(types.appBar.mutations.updateWhite, { white })
    },
    [types.appBar.actions.menuBtn] ({ commit }, { menuBtn }) {
        commit(types.appBar.mutations.menuBtn, { menuBtn })
    },
    [types.appBar.actions.utilBtn] ({ commit }, { utilBtn }) {
        commit(types.appBar.mutations.utilBtn, { utilBtn })
    },
    [types.appBar.actions.backBtn] ({ commit }, { backBtn }) {
        commit(types.appBar.mutations.backBtn, {backBtn})
    },
    [types.appBar.actions.homeBtn] ({ commit }, { homeBtn }) {
        commit(types.appBar.mutations.homeBtn, { homeBtn})
    },
    [types.appBar.actions.drawer] ({ commit }, { drawer }) {
        commit(types.appBar.mutations.drawer, { drawer })
    },
    [types.appBar.actions.hide] ({ commit }, { hide }) {
        commit(types.appBar.mutations.hide, { hide })
    },
    [types.appBar.actions.title] ({ commit }, { title }) {
        commit(types.appBar.mutations.title, { title })
    },
    [types.appBar.actions.color] ({ commit }, { color }) {
        commit(types.appBar.mutations.color, { color })
    }
}

const getters = {
    [types.appBar.getters.getWhite]: state => state.white,
    [types.appBar.getters.menuBtn]: state => state.menuBtn,
    [types.appBar.getters.utilBtn]: state => state.utilBtn,
    [types.appBar.getters.backBtn]: state => state.backBtn,
    [types.appBar.getters.homeBtn]: state => state.homeBtn,
    [types.appBar.getters.drawer]: state => state.drawer,
    [types.appBar.getters.hide]: state => state.hide,
    [types.appBar.getters.title]: state => state.title,
    [types.appBar.getters.color]: state => state.color
}

export default {
    state,
    mutations,
    actions,
    getters
}
